/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 06.07.25
 *
 */

import {ServiceType} from "@shared/Quote/ServiceType";
import BaseIdObject from "@shared/BaseIdObject";
import {ServiceUsageType} from "@shared/Invoice/ServiceUsageType";

export default class ServiceLogItem extends BaseIdObject {


	parentId: string = null;
	
	serviceType: ServiceType = null;
	serviceUsageType: ServiceUsageType = null;

	serviceDateMs: number = null;

	quantity: number = 0;
	itemPriceCents: number = 0
	conversionFactor: number = 1

	usedQuantity: number = 0;
	usedPriceCents: number = 0;

	filterParams = {}

	constructor(options = {}) {
		super();
		this.applyOptions(options);
		// this.id = options.id || null;
		// this.serviceType = options.serviceType || null;
		// this.quantity = options.quantity || 0;
		// this.serviceDateMs = options.serviceDateMs || null;
		// this.filterParams = options.filterParams || {};
	}

}
